import { ORGANIZATIONS, DEFAULT_ORG_ID } from '../config/organizations';
let cachedOrg = null;
const resolveOrg = () => {
    const organization = `${process.env.REACT_APP_ORGANIZATION ?? ''}`.trim().toLowerCase();

    // The env value must be an org id, e.g. "SkyTPO" - casing is the only leeway.
    const match = Object.values(ORGANIZATIONS).find((org) => org.id.toLowerCase() === organization);
    if (match) return match;

    console.warn(
        `[organization] REACT_APP_ORGANIZATION "${process.env.REACT_APP_ORGANIZATION ?? ''}" is not registered in src/config/organizations.js - falling back to "${DEFAULT_ORG_ID}".`
    );
    return ORGANIZATIONS[DEFAULT_ORG_ID];
};

export function getOrgConfig() {
    if (!cachedOrg) cachedOrg = resolveOrg();
    return cachedOrg;
}

export function getLoginVariant() {
    return getOrgConfig().loginVariant;
}

export function getChannelSupport(channel) {
    return getOrgConfig().channelSupport?.[channel] ?? null;
}
